export default "skymp5-front/876052c21af02fe5ce28240072a34ca9.png";